import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router'
import { toast } from 'sonner'

import { useAppSelector } from '@/store/hooks'

import { selectMyNotifications } from '../selectors'

/**
 * Shows a toast when a notification for the signed-in user arrives while the app is open, e.g. from the other tab.
 * Notifications already present on load are not announced, and each id is announced once.
 */
export function useIncomingNotificationToasts(userId: string | undefined) {
  const notifications = useAppSelector(selectMyNotifications)
  const navigate = useNavigate()
  const seen = useRef<{ userId: string | undefined; ids: Set<string> } | null>(null)

  useEffect(() => {
    if (!seen.current || seen.current.userId !== userId) {
      seen.current = { userId, ids: new Set(notifications.map((item) => item.id)) }
      return
    }
    for (const notification of notifications) {
      if (seen.current.ids.has(notification.id)) continue
      seen.current.ids.add(notification.id)
      if (notification.readAt) continue
      toast(notification.title, {
        description: notification.message,
        action: { label: 'View', onClick: () => navigate(notification.route) },
      })
    }
  }, [notifications, userId, navigate])
}
